import dayjs from 'dayjs';
import {useSelector} from 'react-redux';
import {useCallback, useState} from 'react';
import {
  DataGrid,
  GridColDef,
  GridPaginationModel,
  GridRenderCellParams,
  GridSortModel,
} from '@mui/x-data-grid';
import {Box} from '@mui/material';
import {companyIdSelector} from '../../../store/Slices/companySlice';
import {DataGridCustPagination} from '../../../components/utlis/DataGrid/Pagination';
import {GridCellExpand} from '../../../components/utlis/DataGrid/ExpandCellRender';
import {IDataGridSearchSort} from '../../../dto/Html.dto';
import {useRqStingerMessageList} from '../../../react_query/messages/message-requests/StingerMessageList';
import MusicPreviewBtn from '../../../components/music/MusicPreviewBtn';
import CustomNoRowsOverlay from '../../../components/utlis/DataGrid/CustomNoRowsOverlay';
import IconAdd from '../../../asset/icons/icon_messaging.svg';
import InputSearch from '../../../components/styles/InputSearch';
import {GridDurationColumn} from '../../../components/grid/GridColumns';

const columns: GridColDef[] = [
  {
    field: 'url',
    type: 'actions',
    headerName: 'Play',
    width: 54,
    renderCell: (params: GridRenderCellParams) => {
      return params.row.url ? (
        <MusicPreviewBtn id={params.row.id} url={params.row.url} />
      ) : null;
    },
  },
  GridDurationColumn,
  {
    field: 'name',
    headerName: 'Message Name',
    hideable: false,
    width: 180,
  },
  {
    field: 'script',
    headerName: 'Script',
    hideable: false,
    sortable: false,
    flex: 2,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <GridCellExpand
          value={params.row.script}
          width={params.colDef.computedWidth}
        />
      );
    },
  },
  {
    field: 'created_at',
    headerName: 'Created Date',
    hideable: false,
    width: 220,
    renderCell: (params: GridRenderCellParams) => {
      return dayjs(params.value).format('MM/DD/YYYY hh:mm:ss A');
    },
  },
  {
    field: 'created_by',
    headerName: 'Created By',
    hideable: false,
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <GridCellExpand
          value={params.row.created_by.name}
          width={params.colDef.computedWidth}
        />
      );
    },
  },
].map(column => ({
  ...column,
  filterable: false,
}));

const StingersDataGrid = () => {
  const companyId = useSelector(companyIdSelector);

  const [query, setQuery] = useState<IDataGridSearchSort>({
    search: '',
    page: 0,
    pageSize: 10,
  });

  const {data, isLoading} = useRqStingerMessageList(companyId, query);

  const handleSearch = useCallback((val: string) => {
    setQuery(prev => ({
      ...prev,
      search: val,
    }));
  }, []);

  const handlePagination = useCallback((paginate: GridPaginationModel) => {
    setQuery(prev => ({...prev, ...paginate}));
  }, []);

  const handleSortModelChange = (model: GridSortModel) => {
    if (model[0]) {
      setQuery(prev => ({...prev, ...model[0]}));
    }
  };
  return (
    <Box className='GridTableList'>
      <InputSearch
        className='max-w-347 block ml-auto my-3'
        placeholder='Search'
        value={`${query.search}`}
        onChange={handleSearch}
      />
      <Box sx={{height: 'calc(100vh - 250px)'}}>
        <DataGrid
          disableColumnMenu
          disableColumnSelector
          className='custom-data-grid cmc_new_grid h-654 text-white'
          rows={data?.data ?? []}
          columns={columns}
          loading={isLoading}
          rowCount={data?.meta?.total ?? 0}
          paginationModel={{
            page: query.page,
            pageSize: query.pageSize,
          }}
          pageSizeOptions={[10, 25, 50]}
          paginationMode='server'
          onPaginationModelChange={handlePagination}
          sortingMode='server'
          onSortModelChange={handleSortModelChange}
          disableRowSelectionOnClick
          slots={{
            pagination: DataGridCustPagination,
            noRowsOverlay: () => (
              <CustomNoRowsOverlay
                imageSrc={IconAdd}
                message='No stinger messages available'
              />
            ),
          }}
          slotProps={{
            columnsPanel: {
              disableHideAllButton: true,
              disableShowAllButton: true,
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default StingersDataGrid;
